import { combineReducers } from '@reduxjs/toolkit';
import genrateIdsSlice from '@/core/redux/generateIdsSlice';
import themeSettingsSlice from '@/core/redux/themeSettingsSlice';
import forgotPasswordSlice from '@/modules/auth/redux/forgotPasswordSlice';
import IntroductionSlice from '@/modules/auth/redux/IntroductionSlice';
import channelUsersSlice from '@/modules/channel/channelUsers/redux/channelUsersSlices';
// import playlistSlice from '@/modules/channel/contentPlaylist/redux/playlistSlice';
import playlistVideoSlice from '@/modules/channel/contentPlaylistVideo/redux/playlistVideoSlice';
import contentCreationSlice from '@/modules/channel/contentVideo/redux/contentCreation';
import videoSlice from '@/modules/channel/contentVideo/redux/videosSlice';
import channels from '@/modules/channel/redux/Slice';
import shortVideosSlice from '@/modules/channel/shortVideo/redux/shortVideosSlice';
import policiesSlice from '@/modules/cmsManagement/Policies/redux/Slice';
import facebookVideosSlice from '@/modules/facebookPages/videos/redux/facebookVideosSlice';
import companyParameterSlice from '@/modules/parameterManagement/CompanyParameter/redux/Slice';
import licensorParameterSlice from '@/modules/parameterManagement/LicansorParameter/redux/Slice';
import producerParameterSlice from '@/modules/parameterManagement/ProducerParameter/redux/Slice';
/*--- Parameter ---*/
import productParameterSlice from '@/modules/parameterManagement/ProductParameter/redux/Slice';
/*--- Reports ---*/
import companyReportSlice from '@/modules/reports/CompanyReports/redux/Slice';
import langSlice from '@/shared/features/langslice';
import authReducer from '../modules/auth/redux/authSlice';

const rootReducer = combineReducers({
  lang: langSlice,
  auth: authReducer,
  theme: themeSettingsSlice,
  forgotPassword: forgotPasswordSlice,
  introduction: IntroductionSlice,
  video: videoSlice,
  shortVideos: shortVideosSlice,
  contentCreation: contentCreationSlice,
  // playlist: playlistSlice,
  channels,
  generateId: genrateIdsSlice,
  playlistVideo: playlistVideoSlice,
  channelUsers: channelUsersSlice,
  policies: policiesSlice,
  facebookVideos: facebookVideosSlice,

  /*--- Reports ---*/
  companyReports: companyReportSlice,

  /*--- Reports ---*/
  productParameter: productParameterSlice,
  companyParameter: companyParameterSlice,
  licensorParameter: licensorParameterSlice,
  producerParameter: producerParameterSlice,
});

export default rootReducer;
